import { motion } from "framer-motion";
import { useLang } from "../i18n";

export const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;
  const Track = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center whitespace-nowrap font-mono2 text-xs uppercase tracking-[0.25em] text-txt-2">
          <span className="px-6">{item}</span>
          <span className="h-1.5 w-1.5 rotate-45 bg-hadron-cyan/60 inline-block" />
        </span>
      ))}
    </div>
  );

  return (
    <div className="relative border-y border-line bg-ink-2/50 overflow-hidden py-4" data-testid="editorial-marquee">
      <motion.div
        className="flex"
        animate={{ x: ["0%", "-50%"] }}
        transition={{ duration: 42, repeat: Infinity, ease: "linear" }}
      >
        <Track />
        <Track hidden />
      </motion.div>
    </div>
  );
};
